/**
 * Maps an array to another array by a mapped key type.
 *
 * @param input - The input array
 * @param keyMapper - The keys we want
 * @param customKeyCompare - A custom key comparing function if you don't want to use indexOf
 * @returns - The array mapped with the unique key
 */
export function arrayToUnique<T, Key>(
    input: T[],
    keyMapper: (value: T) => Key,
    customKeyCompare?: (key1: Key, key2: Key) => boolean,
): Array<[Key, T[]]> {
    const indexes: Key[] = [];
    const outputArray: Array<[Key, T[]]> = [];

    for (const value of input) {
        const key = keyMapper(value);
        const index = customKeyCompare ? indexes.findIndex(key1 => customKeyCompare(key1, key)) : indexes.indexOf(key);

        if (index >= 0) {
            outputArray[index][1].push(value);
        } else {
            outputArray.push([key, [value]]);
            indexes.push(key);
        }
    }
    return outputArray;
}
